export interface HeroSlide {
  id: string;
  kicker: string;
  title: string;
  subtitle: string;
  meta: string[];
  image: string;
  to: string;
  cta: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-night-train",
    kicker: "最新电影 · 2024",
    title: "夜行列车",
    subtitle:
      "末班列车驶离东京后的第七分钟，一只无人认领的旧皮箱，让六名乘客的夜晚彻底改变。翔田千里主演，黑泽和树执导。",
    meta: ["悬疑 / 剧情", "128 分钟", "主演 · 水野澪"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20night%20train%20platform%20in%20the%20rain%20with%20warm%20amber%20lamp%20glow%20reflecting%20on%20wet%20asphalt%2C%20deep%20navy%20blue%20sky%2C%20empty%20tracks%20and%20distant%20city%20lights%2C%20film%20noir%20atmosphere%2C%20soft%20haze%2C%20wide%20cinematic%20composition%2C%20no%20people%2C%20no%20text&width=1920&height=1080&seq=hero-night-train-main&orientation=landscape",
    to: "/works/detail/night-train",
    cta: "查看作品",
  },
  {
    id: "hero-tide",
    kicker: "口碑之作 · 2023",
    title: "潮汐之信",
    subtitle:
      "一座小岛、一间旧邮局、一批从未寄出的信。翔田千里以极安静的表演，讲述一段被海水冲淡的往事。",
    meta: ["爱情 / 剧情", "116 分钟", "主演 · 三浦千夏"],
    image:
      "https://readdy.ai/api/search-image?query=Serene%20seaside%20harbor%20at%20dusk%20with%20wooden%20boats%20and%20warm%20amber%20lanterns%20reflecting%20on%20calm%20deep%20navy%20water%2C%20soft%20evening%20haze%2C%20distant%20island%20silhouettes%2C%20cinematic%20wide%20composition%2C%20no%20people%2C%20no%20text&width=1920&height=1080&seq=hero-tide-main&orientation=landscape",
    to: "/works/detail/letters-of-the-tide",
    cta: "查看作品",
  },
  {
    id: "hero-interview",
    kicker: "最新访谈",
    title: "我不太相信「爆发力」这回事",
    subtitle:
      "一小时访谈，聊表演的节奏、挑选剧本的标准，以及为什么她越来越喜欢在片场「等一等」。",
    meta: ["访谈", "2024-08-19", "表演方法"],
    image:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20interior%20of%20an%20empty%20rehearsal%20room%20with%20wooden%20floors%20and%20warm%20amber%20window%20light%20cutting%20across%20deep%20navy%20shadows%2C%20dust%20in%20the%20air%2C%20minimal%20elegant%20composition%2C%20wide%20cinematic%20photography%2C%20no%20people%2C%20no%20text&width=1920&height=1080&seq=hero-interview-main&orientation=landscape",
    to: "/news/detail/interview-on-silence",
    cta: "阅读访谈",
  },
];

export const homeStats = [
  { value: "14", label: "影视作品", unit: "部" },
  { value: "5", label: "合作导演", unit: "位" },
  { value: "9", label: "动态资讯", unit: "条" },
  { value: "2010", label: "出道至今", unit: "年" },
];

export const homeIntro =
  "翔田千里影视资料站收录了她自 2010 年出道以来的电影与电视剧作品，以及近年来的访谈、活动与出版动态。这里不做播放与下载，只把作品本身、幕后细节和时间线整理清楚，供影迷与影视研究者查阅。";

export const quickKeywords: string[] = ["夜行列车", "潮汐之信", "访谈", "悬疑", "白色回廊"];